<template>
  <div class="h-100 d-flex flex-column align-center justify-space-around fit-content mx-auto ga-5" ref="outerDiv">
    <ConnectingLine
      :startElementId="`query-${system.index}-${event.index}`"
      :endElementId="`role-${system.index}-${system.roles[event.index].id}`"
      :refreshKey="refreshKey"
      offsetParentId="domain-model"
    />
    <div
      :id="`query-${system.index}-${event.index}`"
      :class="{
        'model-card-border': system.queries[event.index].length > 1,
        'model-card-border-hover': !!system.queries[event.index].length
      }"
      :style="{ '--border-color': system.queries[event.index].length ? cardTypeColor(queryCardType) : '' }"
      class="w-100"
    >
      <div v-if="system.queries[event.index].length" ref="queryEl">
        <template v-for="(query, queryIndex) in queriesByBoundedContext" :key="`${query.id}`">
          <ConnectingLine
            v-if="!query.divider"
            :startElementId="`query-${system.index}-${event.index}-${queryIndex}`"
            :endElementId="`query-${system.index}-${event.index}-${queryIndex + 1}`"
            :refreshKey="refreshKey"
            direction="vertical"
            offsetParentId="domain-model"
          />
          <domain-model-query-card
            :query="query"
            :queryIndex="queryIndex"
            :system="system"
            :event="event"
            :showEntities="showEntities"
          />
        </template>
      </div>
      <v-btn
        v-else-if="queryCardType"
        class="add-card-btn"
        variant="elevated"
        block
        data-cy="add-read-model-btn"
        @click="createCard(event.id, queryCardType.id, `<p>${queryCardType.title} for ${event.description}</p>`)"
        :style="{ '--border-color': cardTypeColor(queryCardType) }"
        :id="`query-${system.index}-${event.index}-${- 1}`"
        :disabled="store.state.isWorkflowDisabled"
      >
        <v-icon size="large">mdi-plus</v-icon>
      </v-btn>
      <aggregate-type-selector
        v-else
        :cardTypes="cardTypes"
        :type="DomainModelRole.READ_MODEL"
      />
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import ConnectingLine from '@/components/ConnectingLine'
import AggregateTypeSelector from '@/components/AggregateTypeSelector'
import DomainModelQueryCard from '@/components/DomainModelQueryCard.vue'
import { diagramHelpers } from '@/mixins/diagramHelpers'
import useDomainModel from '@/composables/useDomainModel'
import { DomainModelRole } from '@/constants/cardTypes'

const {
  system,
  event,
  refreshKey,
  showEntities
} = defineProps({
  system: Object,
  event: Object,
  refreshKey: Number,
  showEntities: Boolean
})

const store = useStore()
const workflow = computed(() => store.state.workflow.workflow)
const cardTypes = computed(() => store.state.cardTypes.cardTypes)
const queryCardType = computed(() => diagramHelpers.methods.getQueryCardType(cardTypes.value))

const { cardTypeColor, createCard } = useDomainModel()

const queryEl = ref(null)

const queriesByBoundedContext = computed(() => {
  return system.queries[event.index].map((query) => {
    let isInContext = false
    const queryEntityId = query.schemaData.schema?.entityId

    if (!queryEntityId || !system.groupedBy?.boundedContext) {
      isInContext = true
    }

    const entity = (workflow.value.schemas ?? []).find((item) => item.id === queryEntityId)

    if (!entity || entity.boundedContext === system.groupedBy?.boundedContext) {
      isInContext = true
    }

    return { ...query, isInContext }
  })
})

</script>

<style scoped>
.model-card-border {
  border: 1px dashed var(--border-color);
  border-radius: 8px;
  padding: 8px;
}

:deep(.model-card-border-hover) {
  .add-more-query-btn {
    transition: all 0.2s;
    opacity: 0;
  }

  &:hover {
    .add-more-query-btn {
      opacity: 1;
    }
  }
}
</style>
